import React, { useState, useEffect, useRef, useContext } from "react";
import { GlobalContext } from "./header/GlobalContext";
import { createRoot } from "react-dom/client";
import { GlobalProvider } from "./header/GlobalContext.js";
import FetchAthletes from "./FetchAthletes.js";
import FetchStats from "./FetchStats.js";
import AthleteCard from "./AthleteCard.js";
import StatSelection from "./header/StatSelection.js";
import PromoOffers from "./header/PromoOffers.js";
import Sidebar from "./sidebar/Sidebar.js";
import SportSelection from "./header/SportSelection.js";
import HardModal from "./modals/HardModal.js";
import EasyModal from "./modals/EasyModal.js";
import PromoModal from "./modals/PromoModal.js";
import HowToPlayModal from "./modals/HowToPlayModal.js";
import H2HMatchModal from "./modals/H2hMatchModal.js";
import IconsExplainedModal from "./modals/IconsExplainedModal.js";
import SearchInput from "./header/SearchInput.js";
import GeoLocate from "./GeoLocate.js";
import toastr from "toastr";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import "toastr/toastr.scss";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
// import sendAthleteSelectionToAPI from "./sendAthleteSelectionToAPI.js";
const urlParams = new URLSearchParams(window.location.search);
const h2hParam = urlParams.get('h2h');
const loggedIn = document.body.classList.contains('logged-in');

const App = () => {
  const [athletes, setAthletes] = useState(false);
  const [loading, setLoading] = useState(true);
  const [athletesLoading, setAthletesLoading] = useState(true);
  const [selected, setSelected] = useState([]);
  const [stats, setStats] = useState([]);
  const [stat, setStat] = useState("");
  const balance = document.getElementById("balance").value;
  const [sport, setSport] = useState("");
  const [sports, setSports] = useState([]);
  const fetchAttemptsRef = useRef(0);
  const [darkMode, setDarkMode] = useState(true);
  const [darkTxt, setDarkTxt] = useState('<i class="fa-solid fa-sun"></i> Light Mode');
  const { multiplier } = useContext(GlobalContext);
  const [maxAthletes, setMaxAthletes] = useState(6);
  const [verifiedStats, setVerifiedStats] = useState({});
  const h2hCount = document.getElementById("h2h-count")?.value;
  const verifiedAcct = document.getElementById("verified")?.value;

  const fetchInitialData = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const sportParam = urlParams.get("sport");

      const newVerifiedStats = await FetchStats();
      setVerifiedStats(newVerifiedStats);
      let verifiedSports = Object.keys(newVerifiedStats);
      let firstSport = verifiedSports[0];
      let selectedSport = verifiedSports.includes(sportParam) ? sportParam : firstSport;
      let firstStat = Object.keys(newVerifiedStats[selectedSport])[0];
      let stats = newVerifiedStats[selectedSport];

      setSports(verifiedSports);
      setSport(selectedSport);
      setStats(stats);
      setStat(firstStat);
      setLoading(false);

      const response = await FetchAthletes(selectedSport, firstStat);
      setAthletes(response);
      setAthletesLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {

    // check for param msg
    // const msg = urlParams.get('promo');
    // if (msg =='5x' || msg == '3x') {
    //   toastr["success"]('Promo $5 for $25 is active for the next 30 minutes.', "Activated");
    // }

    const emailVerified = urlParams.get('email_verified');
    if (emailVerified == 1) {
      toastr["success"]('Your email has been verified successfully.', "Email Verified");
    }

    // Load selected athletes from localStorage
    /*
    const savedSelected = localStorage.getItem("selected");
    if (savedSelected) {
      const parsedSelected = JSON.parse(savedSelected);
      // Make sure no athletes start time has passed
      let currentTime = new Date();
      let validSelected = parsedSelected.filter(
        (x) => new Date(x.start_time_obj) >= currentTime
      );
      setSelected(validSelected);
      setPayoutMultiplier(validSelected.length);
    }
    */

    toastr.options = {
      closeButton: true,
      debug: false,
      newestOnTop: true,
      progressBar: true,
      positionClass: "toast-top-full-width",
      preventDuplicates: true,
      onclick: null,
      showDuration: "800",
      hideDuration: "1000",
      timeOut: "5000",
      extendedTimeOut: "1000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
    };

    fetchInitialData();

    if (h2hCount > 0) {
      setMaxAthletes(h2hCount);
      setTimeout(() => {
        $("#h2h-match-modal").modal('show');
      }, 1000);
    }

  }, []);

  useEffect(() => {
    // Save selected athletes to localStorage whenever it changes
    localStorage.setItem("selected", JSON.stringify(selected));
  }, [selected]);

  // Inactivity Check, update stats every 15 minutes if no activity
  useEffect(() => {
    let lastActivityTime = Date.now();

    const resetTimer = () => {
      lastActivityTime = Date.now();
    };

    const checkInactivity = () => {
      if (Date.now() - lastActivityTime > 15 * 60 * 1000) { // 15 minutes
        fetchInitialData();
        lastActivityTime = Date.now(); // Reset the timer after fetching data
      }
    };

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        checkInactivity();
      }
    };

    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keypress", resetTimer);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    const interval = setInterval(checkInactivity, 60 * 1000); // Check every minute

    return () => {
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keypress", resetTimer);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      clearInterval(interval);
    };
  }, []);

  const handleChatClick = () => {
    const stickyMenu = document.querySelector('.sticky-menu');
    const stickyFooter = document.querySelector('.sticky-footer');
    if (stickyMenu.style.display === 'none') {
      stickyMenu.style.setProperty('z-index', '200000000099', 'important');
      stickyFooter.style.setProperty('z-index', '200000000099', 'important');
    } else {
      stickyMenu.style.setProperty('z-index', '10', 'important');
      stickyFooter.style.setProperty('z-index', '10', 'important');
    }
  }

  const getAthletes = (sport, stat) => {
    FetchAthletes(sport, stat).then((response) => {
      let stats = verifiedStats[sport];
      if ((response === undefined || response.length === 0) && fetchAttemptsRef.current >= 2 && sports.length > 0) {
        let nextSport = sports.shift();
        setSport(nextSport);
        let nextStats = verifiedStats[nextSport];
        setStats(nextStats);
        let firstStat = Object.keys(verifiedStats[nextSport])[0];
        setStat(firstStat);
        fetchAttemptsRef.current = 0; // Reset fetchAttempts when switching sports
        getAthletes(nextSport, firstStat);
      } else if (response && response.length === 0 && fetchAttemptsRef.current < 2 && Object.keys(stats).length > 0) {
        fetchAttemptsRef.current += 1;
        const statKeys = Object.keys(stats);
        const currentIndex = statKeys.indexOf(stat);
        const nextStat = currentIndex !== -1 && currentIndex < statKeys.length - 1 ? statKeys[currentIndex + 1] : null;
        getAthletes(sport, nextStat);
      } else if (response && response.length > 0) {
        setLoading(false);
        setAthletes(response);
        setSport(sport);
        setAthletesLoading(false);
        fetchAttemptsRef.current = 0; // Reset fetchAttempts on successful fetch
      }
    });
  };

  // Helper to handle stat change and fallback to next stat if no athletes found
  const handleStatChange = (selectedSport, statValue, statsObj = null) => {
    const stats = statsObj || verifiedStats[selectedSport];
    setStat(statValue);
    setStats(stats);
    setAthletesLoading(true);
    FetchAthletes(selectedSport, statValue).then((response) => {
      if ((response === undefined || response.length === 0) && Object.keys(stats).length > 0) {
        const statKeys = Object.keys(stats);
        const currentIndex = statKeys.indexOf(statValue);
        const nextStat = currentIndex !== -1 && currentIndex < statKeys.length - 1 ? statKeys[currentIndex + 1] : null;
        if (nextStat) {
          handleStatChange(selectedSport, nextStat, stats);
        } else {
          setAthletes([]);
          setAthletesLoading(false);
        }
      } else if (response && response.length > 0) {
        setAthletes(response);
        setAthletesLoading(false);
      } else {
        setAthletes([]);
        setAthletesLoading(false);
      }
    });
  };

  const selectProp = (e) => {
    let prop = e.currentTarget.dataset.prop;
    let value = e.currentTarget.value;

    if (prop.includes("more") || prop.includes("less") || prop === "delete") {

      let selectedAthleteID = value;

      // Count of selected athletes
      let selectedCount = selected.length;
      selectedCount = prop === "delete" ? selectedCount - 1 : selectedCount + 1;
      // setPayoutMultiplier(selectedCount);

      let selectedAthleteStat = e.currentTarget.dataset.stat;
      let statValue = e.currentTarget.dataset.value;
      let promo = e.currentTarget.dataset.promo;

      let athleteIndex = athletes.findIndex(
        (x) => x.athlete_id == selectedAthleteID && x.stat_key == selectedAthleteStat
      );
      let athlete = athletes[athleteIndex];
      if (statValue) {
        athlete.stat = statValue;
      }
      if (promo === 'easy') {
        athlete.easy = true;
        athlete.hard = false;
      } else if (promo === 'hard') {
        athlete.hard = true;
        athlete.easy = false;
      }

      let delIndex = selected.findIndex(
        (x) => x.athlete_id == selectedAthleteID && x.stat_key == selectedAthleteStat
      );
      if (delIndex > -1 && prop === "delete") {
        let newSelected = [...selected];
        newSelected.splice(delIndex, 1);
        setSelected(newSelected);
        return;
      }

      let oppositeIndex = selected.findIndex(
        (x) => x.athlete_id == selectedAthleteID && x.stat_key == selectedAthleteStat && x.selected != prop
      );
      if (oppositeIndex > -1) {
        let newSelected = [...selected];
        newSelected.splice(oppositeIndex, 1);
        setSelected(newSelected);
      }

      let selectedAthlete = selected.find(
        (x) => x.athlete_id == selectedAthleteID && x.stat_key == selectedAthleteStat
      );

      if (selected.length >= maxAthletes && !selectedAthlete) {
        toastr["warning"](`You have reached the max ${maxAthletes} Athlete Line-up.`, "Notice");
        return;
      }

      let index = selected.findIndex(
        (x) => x.athlete_id == selectedAthleteID && x.stat_key == selectedAthleteStat && x.selected == prop
      );
      if (index > -1) {
        let newSelected = [...selected];
        newSelected.splice(index, 1);
        setSelected(newSelected);
        return;
      }

      // if (prop !== "delete") {
      //   sendAthleteSelectionToAPI(athlete);
      // }

      athlete.selected = prop;
      setSelected((prevSelected) => [...prevSelected, athlete]);
      return;
    }

    if (prop === "sport" || prop === "stat") {
      let selectedSport = prop === "sport" ? value : sport;
      setSport(selectedSport);

      if (prop === "sport") {
        setAthletesLoading(true);
        FetchStats().then((newVerifiedStats) => {
          if (newVerifiedStats !== null) {
            setVerifiedStats(newVerifiedStats);
          }
          let stats = verifiedStats[selectedSport];
          let firstStat = Object.keys(stats)[0];
          handleStatChange(selectedSport, firstStat, stats);
        });
      } else {
        handleStatChange(selectedSport, value);
      }
    }
  };

  const handleScroll = () => {
    const selectedContainer = document.getElementById("balance-box");
    selectedContainer.scrollIntoView({ behavior: "smooth" });
  };

  const handleModal = (type) => {
    if ($(".modal-dialog").is(":visible")) {
      return;
    }

    if (type === "how-to-play") {
      $("#how-to-play-modal").modal("show");
    } else if (type === "icons-explained") {
      $("#icons-explained-modal").modal("show");
    }
  };

  const handleDarkToggle = () => {
    if (darkMode) {
      document.body.classList.remove("dark-mode");
      setDarkMode(false);
      setDarkTxt('<i class="fa-solid fa-moon"></i> Dark Mode');
    } else {
      document.body.classList.add("dark-mode");
      setDarkMode(true);
      setDarkTxt('<i class="fa-solid fa-sun"></i> Light Mode');
    }
  };

  const mobileMultiplier = () => {
    switch (selected.length) {
      case 2:
        return 3;
      case 3:
        return 5;
      case 4:
        return 10;
      case 5:
        return 20;
      case 6:
        return 25;
      default:
        return '';
    }
  }

  if (loading) {
    return (
      <div className="container text-center loading">
        <div className="d-flex justify-content-center">
            <DotLottieReact
              style={{ width: '100px', height: '100px' }}
              src="/wp-content/themes/understrap-child/src/site/lottie/ww-loading.lottie"
              loop
              autoplay
            />
        </div>
        <div>Loading Board</div>
      </div>
    );
  }

  if (!athletes && !athletesLoading) {
    return (
      <div className="container text-center">
        {sports.length > 1 && (
          <div className="mb-3">
            <SportSelection sports={sports} sport={sport} onClick={selectProp} />
          </div>
        )}

        <StatSelection stats={stats} stat={stat} sport={sport} onClick={selectProp} />
        <div className="w-100 mt-5">No Athletes Found. Change stat or league.</div>
      </div>
    );
  }

  return (
    <div className="text-center mt-3">
      {sports.length > 0 && (
        <div className="mb-3">
          <SportSelection sports={sports} sport={sport} onClick={selectProp} />
        </div>
      )}

      <StatSelection stats={stats} stat={stat} sport={sport} onClick={selectProp} />

      {!verifiedAcct && (
        <PromoOffers />
      )}

      <GeoLocate />
      <HardModal />
      <EasyModal />
      <PromoModal />
      <HowToPlayModal />
      <IconsExplainedModal />
      {h2hParam && <H2HMatchModal />}

      <div className="d-flex flex-wrap mt-4">
        <div className="col-md-7 col-sm-12 p-010 d-flex align-items-center">
          <div className="how-to-play">
            <span onClick={() => handleModal("how-to-play")} className="mr-2">
              <i className="fa-solid fa-gamepad"></i> How to Play
            </span>{" "}
            <span onClick={() => handleModal("icons-explained")} className="ml-2 mr-2">
              <i className="fa-solid fa-circle-info"></i> Icons Explained
            </span>{" "}
            <span className="ml-2 mr-2">
              <a href="javascript:void(Tawk_API.toggle())">
                <i className="fa-solid fa-circle-question"></i> Support
              </a>
            </span>{" "}
            <span
              onClick={() => handleDarkToggle()}
              className="ml-2"
              dangerouslySetInnerHTML={{ __html: darkTxt }}
            ></span>
          </div>
        </div>

        <SearchInput
          sport={sport}
          stat={stat}
          setLoading={setLoading}
          setAthletes={setAthletes}
          setAthletesLoading={setAthletesLoading}
          getAthletes={getAthletes}
        />
      </div>

      <div className="d-flex flex-wrap flex-md-nowrap">
        {athletesLoading && (
          <div className="container text-center">
            <div className="athletes-loading d-flex justify-content-center w-100">
              <DotLottieReact
                style={{ width: '100px', height: '100px' }}
                src="/wp-content/themes/understrap-child/src/site/lottie/ww-loading.lottie"
                loop
                autoplay
              />
            </div>
            <div className="d-flex justify-content-center w-100">
              <div className="mt-2 mb-5">Loading Athletes</div>
            </div>
          </div>
        )}
        {!athletes || (athletes.length === 0 && !athletesLoading) && (
          <div className="w-100 mt-5">No Athletes Found. Change stat or leage.</div>
        )}

        <div className="d-flex flex-wrap justify-content-md-start align-self-baseline h-100">
          {!athletesLoading &&
            athletes.length > 0 &&
            athletes.map((athleteData, index) => {
              return (
                <AthleteCard
                  key={athleteData.athlete_id}
                  index={index}
                  athlete={athleteData}
                  onClick={selectProp}
                  selected={selected}
                />
              );
            })}
        </div>
        <Sidebar
          selected={selected}
          onClick={selectProp}
          balance={balance}
        />
      </div>

      {selected.length > 1 && (
        <div className="sticky-footer d-md-none w-100">
          <button onClick={handleScroll} className="btn btn-primary">
            <div id="selected">
              {selected.length} Picks
              <br />
              Up to {mobileMultiplier()}X Payout
            </div>{" "}
            <div id="ce-btn">
              Complete Entry <i className="fa-solid fa-arrow-right"></i>
            </div>
          </button>
        </div>
      )}


      <div className="sticky-menu d-md-none w-100 d-flex align-items-center">
        {loggedIn ? (
          <a href="/my-account/" className="col">
            <svg className="h-25px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path fill-rule="evenodd" d="M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" clip-rule="evenodd"></path>
            </svg>
            <br/> Account
          </a>
        ) : (
          <div className="lrm-login col">
            <svg className="h-25px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path fill-rule="evenodd" d="M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" clip-rule="evenodd"></path>
            </svg>
            <br/> Account
          </div>
        )}

        <a href="/invite-friends/" className="col">
          <svg className="h-25px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M10.464 8.746c.227-.18.497-.311.786-.394v2.795a2.252 2.252 0 0 1-.786-.393c-.394-.313-.546-.681-.546-1.004 0-.323.152-.691.546-1.004ZM12.75 15.662v-2.824c.347.085.664.228.921.421.427.32.579.686.579.991 0 .305-.152.671-.579.991a2.534 2.534 0 0 1-.921.42Z"></path>
            <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v.816a3.836 3.836 0 0 0-1.72.756c-.712.566-1.112 1.35-1.112 2.178 0 .829.4 1.612 1.113 2.178.502.4 1.102.647 1.719.756v2.978a2.536 2.536 0 0 1-.921-.421l-.879-.66a.75.75 0 0 0-.9 1.2l.879.66c.533.4 1.169.645 1.821.75V18a.75.75 0 0 0 1.5 0v-.81a4.124 4.124 0 0 0 1.821-.749c.745-.559 1.179-1.344 1.179-2.191 0-.847-.434-1.632-1.179-2.191a4.122 4.122 0 0 0-1.821-.75V8.354c.29.082.559.213.786.393l.415.33a.75.75 0 0 0 .933-1.175l-.415-.33a3.836 3.836 0 0 0-1.719-.755V6Z" clip-rule="evenodd"></path>
          </svg>
          <br/> Get $50
        </a>

        <a href="/promos/"className="col">
          <svg className="h-25px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path fill-rule="evenodd" d="M14.615 1.595a.75.75 0 0 1 .359.852L12.982 9.75h7.268a.75.75 0 0 1 .548 1.262l-10.5 11.25a.75.75 0 0 1-1.272-.71l1.992-7.302H3.75a.75.75 0 0 1-.548-1.262l10.5-11.25a.75.75 0 0 1 .913-.143Z" clip-rule="evenodd"></path>
          </svg>
          <br/> Promos
        </a>

        <a onClick={handleChatClick} href="javascript:void(Tawk_API.toggle())" id="chat-btn" className="col">
          <svg className="h-25px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path fill-rule="evenodd" d="M4.804 21.644A6.707 6.707 0 0 0 6 21.75a6.721 6.721 0 0 0 3.583-1.029c.774.182 1.584.279 2.417.279 5.322 0 9.75-3.97 9.75-9 0-5.03-4.428-9-9.75-9s-9.75 3.97-9.75 9c0 2.409 1.025 4.587 2.674 6.192.232.226.277.428.254.543a3.73 3.73 0 0 1-.814 1.686.75.75 0 0 0 .44 1.223ZM8.25 10.875a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25ZM10.875 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875-1.125a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z" clip-rule="evenodd"></path>
          </svg>
          <br/> Support
        </a>
      </div>


    </div>
  );
};

const container = document.getElementById("react-load");
const root = createRoot(container);
root.render(
  <GlobalProvider>
    <App />
  </GlobalProvider>
);